import "./CentralStation.css"

import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

import KintoButton from "../../components/KintoButton"

type OwnProps = {
  headerStartFlat?: boolean
  pages?: Array<{
    route: string
    imgSrc?: string
    label?: string
    disabled?: boolean
    hidden?: boolean
  }>
}

const CentralStation = (props: OwnProps): React.ReactElement => {
  const { pages } = props
  const navigate = useNavigate()
  const [isHeaderFlat, setIsHeaderFlat] = useState(props.headerStartFlat)

  const handleNavigation = (route: string) => {
    navigate(route)
  }

  useEffect(() => {
    if (!isHeaderFlat) {
      setTimeout(() => {
        setIsHeaderFlat(true)
      }, 2000)
    }
  }, [isHeaderFlat])

  return (
    <div id="central-station-body" className="central-station-body">
      <ul className="central-station-routes-list">
        {
          pages?.map((page, i) => {
            if (page.hidden) return <></>

            else if (page.imgSrc) {
              return (<li key={i} className="central-station-routes-list-item"><a className="clickable" onClick={() => { handleNavigation(page.route) }}><img className="central-station-image-route" src={page.imgSrc} alt={page.label}/></a></li>)
            } else if (page.label) {
              return (<KintoButton key={i} onClick={() => {
                handleNavigation(page.route)
              }}>{page.label}</KintoButton>)
            } else return (<></>)
          })
        }
      </ul>
    </div>
  )
}

export default CentralStation
